// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useState} from 'react';
import {AUTH_TAB, EULA_LINK, PRIVACY_LINK,
    NEW_TAB_ATTRS} from '../../utils/constants.js';
import * as oauth from '../../utils/oauth.js';
import {Popup} from '../../comp/popup';
import {Oauth_btn} from '../../comp/oauth_btn';
import {Checkbox} from '../../comp/checkbox';
import {Icon} from '../../comp/icon';
import {Tabs} from '../../comp/tabs';
import {Text} from '../../comp/text';
import wallet_url from './wallet.svg?url';
import gift_url from './gift_box.svg?url';
import * as cns from './auth_popup.module.less';

const TABS = [{
    value: AUTH_TAB.SIGN_IN,
    label: 'Sign In',
}, {
    value: AUTH_TAB.SIGN_UP,
    label: 'Sign Up',
}];

function Sign_up_content(){
    return <ul className={cns.signup_content}>
      <li>
        <Text.s span className={cns.signup_content_count} accent>1</Text.s>
        <Text.m span>Create an account</Text.m>
      </li>
      <li>
        <Text.s span className={cns.signup_content_count} accent>2</Text.s>
        <Text.m span>Get instant $5.00!</Text.m>
      </li>
    </ul>;
}

function Left_panel({tab}){
    const is_signin = tab==AUTH_TAB.SIGN_IN;
    const img_url = is_signin ? wallet_url : gift_url;
    return <div className={cns.left_area}>
      <Icon className={cns.logo} ico="earnapp_logo" as="img"/>
      <img key={tab} className={cns.img} src={img_url}/>
      {!is_signin&&<Sign_up_content/>}
    </div>;
}

function Checkbox_label(){
    return <Text.s span secondary bold>
      I agree to the{' '}
      <a href={PRIVACY_LINK} {...NEW_TAB_ATTRS}>Privacy Policy</a>{' '}
      and{' '}
      <a href={EULA_LINK} {...NEW_TAB_ATTRS}>EULA</a>
    </Text.s>;
}

function Buttons({meta, disabled}){
    return <ul className={cns.buttons}>
      {meta.google.enabled&&<li>
        <Oauth_btn url={meta.google.url} logo="google_logo" size="l"
          disabled={disabled}>
          {meta.action_label} with Google
        </Oauth_btn>
      </li>}
      {meta.apple.enabled&&<li>
        <Oauth_btn url={meta.apple.url} logo="apple_logo" size="l"
          disabled={disabled}>
          {meta.action_label} with Apple
        </Oauth_btn>
      </li>}
    </ul>;
}

function Sign_up(){
    const meta = oauth.get_meta(true);
    const [checked, set_checked] = useState(false);
    return <div className={cns.auth_wrap}>
      <Checkbox checked={checked} on_change={set_checked} no_background
        label={<Checkbox_label/>} check_placement="left"
        className={cns.check}/>
      <Buttons meta={meta} disabled={!checked}/>
      <Text.s tertiary>
        Users are not allowed to use multiple accounts, complete offers on
        behalf of other users, or utilize VPNs, VPS, or virtual machine
        software in any way.
      </Text.s>
    </div>;
}

function Sign_in(){
    const meta = oauth.get_meta();
    return <div className={cns.auth_wrap}>
      <Buttons meta={meta}/>
      <Text.s tertiary>
        By signing in, you are agreeing to our{' '}
        <a href={EULA_LINK} {...NEW_TAB_ATTRS}>Terms of Service</a> and{' '}
        <a href={PRIVACY_LINK} {...NEW_TAB_ATTRS}>Privacy Policy.</a>{' '}
        General prohibited users using multiple accounts, completing offers on
        another user's account, or using any type of VPN, VPS or Emulator
        software.
      </Text.s>
    </div>;
}

function Right_panel({tab, on_change}){
    return <div className={cns.right_area}>
      <Tabs items={TABS} size="m" active_value={tab} on_activate={on_change}
        fill_width/>
      {tab==AUTH_TAB.SIGN_IN&&<Sign_in/>}
      {tab==AUTH_TAB.SIGN_UP&&<Sign_up/>}
    </div>;
}

export function Content({default_tab}){
    const [tab, set_tab] = useState(default_tab || TABS[0].value);
    return <div className={cns.root}>
      <Left_panel tab={tab}/>
      <Right_panel tab={tab} on_change={set_tab}/>
    </div>;
}

export function Auth_popup({default_tab, show, on_close}){
    return <Popup hide_header show={show} on_close={on_close} hide_actions
      no_padding>
      <Content default_tab={default_tab} />
    </Popup>;
}
